
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^7(28|87|93)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
